import {
  createConnectionApiAction,
  createConnectorAddedSuccessStep,
  createFullWidthRowLayout,
} from './connectorSchema.helpers';

export const SophosSchema = {
  name: 'Sophos Connector',
  steps: {
    0: {
      name: 'Step 1',
      elements: [
        {
          type: 'description',
          description: 'Please provide API credentials to connect.',
          column: 0,
        },
        {
          name: 'clientId',
          label: 'Client ID',
          description: 'Please enter your Sophos client ID',
          type: 'text',
          required: true,
          column: 1,
        },
        {
          name: 'clientSecret',
          label: 'Client Secret',
          description: 'Please enter your Sophos client secret',
          type: 'password',
          required: true,
          column: 2,
        },
      ],
      layout: createFullWidthRowLayout(3),
      action: createConnectionApiAction(),
    },
    1: createConnectorAddedSuccessStep(
      'Sophos has been successfully added as a connector.'
    ),
  },
};
